import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import InventoryScreen from '../screens/inventory/InventoryScreen';
import AddEditMaterialScreen from '../screens/inventory/AddEditMaterialScreen';
import AddEditReadymadeScreen from '../screens/inventory/AddEditReadymadeScreen';

const Stack = createNativeStackNavigator();

const InventoryNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="InventoryMain" component={InventoryScreen} />
      <Stack.Screen name="AddEditMaterial" component={AddEditMaterialScreen} />
      <Stack.Screen name="AddEditReadymade" component={AddEditReadymadeScreen} />
    </Stack.Navigator>
  );
};

export default InventoryNavigator;
